import { render, staticRenderFns } from "./appTabs.vue?vue&type=template&id=1bf60422&scoped=true&"
import script from "./appTabs.vue?vue&type=script&lang=js&"
export * from "./appTabs.vue?vue&type=script&lang=js&"
import style0 from "./appTabs.vue?vue&type=style&index=0&id=1bf60422&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf60422",
  null
  
)

export default component.exports